import { render, staticRenderFns } from "./BotNotificacoes.vue?vue&type=template&id=84f56bb0&scoped=true"
import script from "./BotNotificacoes.vue?vue&type=script&lang=js"
export * from "./BotNotificacoes.vue?vue&type=script&lang=js"
import style0 from "./BotNotificacoes.vue?vue&type=style&index=0&id=84f56bb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f56bb0",
  null
  
)

export default component.exports